







































import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { WidgetInformationTopic } from '@/api/types'
import { Company } from '@/api/model/company'

@Component
export default class EditEmmaWidgetForm extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>

    @Prop({ required: true }) readonly company: Company

    get defaultWidgetInformationTopic(): WidgetInformationTopic {
        return {
            topic: '',
            tag: '',
        }
    }
}
